module.exports = __webpack_public_path__ + "static/media/notificationComplication.292685ed.png";